import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { QueuesPage } from "@/features/queues/QueuesPage";

const search = z.object({
  client: z.string().optional(),
  type: z.string().optional(),
});

export const Route = createFileRoute("/_app/queues/$role")({
  validateSearch: search,
  component: () => <QueuesPage role={Route.useParams().role} search={Route.useSearch()} />,
});
